import { Row, Col } from "antd";
import React from "react";
import WeaHelpfulTip from "../wea-helpful-tip";
import middleware from "../../middleware";

class SearchGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showGroup: props.showGroup ? props.showGroup : false
    };
  }
  componentWillReceiveProps(nextProps) {
    if (
      "showGroup" in nextProps &&
      this.state.showGroup !== nextProps.showGroup
    ) {
      this.setState({ showGroup: nextProps.showGroup });
    }
  }
  render() {
    const {
      title,
      items,
      needTigger = true,
      col = 2,
      customComponent = "",
      children,
      fontSize,
      style = {},
      center,
      size,
      hide,
      multiCol,
      titleTip = null
    } = this.props;
    const { showGroup } = this.state;
    return (
      <div
        className={`wea-search-group ${this.props.className || ""} ${
          hide ? "wea-hide" : "wea-show"
        }`}
        style={style}
      >
        {title && (
          <Row className="wea-title">
            <Col span={customComponent === "" ? 23 : 10}>
              <div style={{ fontSize }} className="wea-f12 text-elli">
                {title}
                {titleTip && (
                  <span style={{ "margin-left": "5px" }}>
                    <WeaHelpfulTip {...titleTip} />
                  </span>
                )}
              </div>
            </Col>
            {customComponent && (
              <Col
                className={"wea-f12"}
                span={13}
                style={{ textAlign: "right", paddingRight: 10 }}
              >
                {customComponent}
              </Col>
            )}
            {needTigger && (
              <Col
                className={"wea-f12"}
                span={1}
                style={{ textAlign: "right", paddingRight: 10 }}
              >
                <i
                  className={showGroup ? "icon-coms-up" : "icon-coms-down"}
                  onClick={() => {
                    this.setState({ showGroup: !showGroup });
                    this.props.onVisibleChange &&
                      this.props.onVisibleChange(!showGroup);
                  }}
                />
              </Col>
            )}
          </Row>
        )}
        <Row
          className={`wea-content ${center ? "center" : ""} ${
            multiCol ? "multiCol" : ""
          } ${title ? "pt15" : ""}`}
          style={showGroup ? {} : { display: "none" }}
        >
          <div className={`wea-form-cell-wrapper clearfix  ${size || ""}`}>
            {items &&
              items.map(obj => {
                if (obj) {
                  let cellNum = obj.col || col;
                  if (center) cellNum = 1;
                  return (
                    <Col
                      className={`wea-form-cell ${obj.hide ? "wea-hide" : ""}`}
                      span={24 / cellNum}
                    >
                      {obj.com}
                    </Col>
                  );
                }
              })}
            {children}
          </div>
        </Row>
      </div>
    );
  }
}

const Com = middleware(SearchGroup, "WeaSearchGroup");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-search-group/index.js